import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms'; // <-- Import this

import { ChatRoutingModule } from './chat-routing.module';

// Declare our new components
import { ChatWindowComponent } from './components/chat-window/chat-window.component';
import { ChatHistoryComponent } from './components/chat-history/chat-history.component';
import { SharedModule } from '../../shared/shared.module';
import { UserChatWinodowComponent } from './components/user-chat-winodow/user-chat-winodow.component';
import { OverlayChatWindowComponent } from './components/overlay-chat-window/overlay-chat-window.component';
import { CodingAnswerComponent } from './components/coding-answer/coding-answer.component';

@NgModule({
  declarations: [
    ChatWindowComponent,
    ChatHistoryComponent,
    UserChatWinodowComponent,
    OverlayChatWindowComponent
  ],
  imports: [
    CommonModule,
    ChatRoutingModule,
    SharedModule,
    FormsModule,
    CodingAnswerComponent
  ],
  exports: [
    ChatHistoryComponent,
    ChatWindowComponent
  ]
})
export class ChatModule { }
